import { useBreadcrumbs } from "@/hooks/useBreadcrumbs";
import { ROUTES } from "@/constants/routeConstants";
import { useTranslation } from "react-i18next";
import { ContentCrud } from "./ContentCrud";

export const ContentPage = () => {
  const { t } = useTranslation();

  useBreadcrumbs([
    {
      name: t("Content"),
      path: ROUTES.CONTENT,
    },
  ]);

  return <ContentCrud />;
};
